import {
  useGaTrackingConfig,
  trackEvent,
  getImageUrl,
} from "../../Utility/Utility";
import defaultImage from "../../../../src/Assets/fallbackimg_giftcard.png";

function getCanonicalUrl() {
  return window.location.href.includes("/card?")
    ? window.location.href.replace("/card?", "/giftcard?")
    : window.location.href;
}

export function useCheckoutAnalytics({ cardListData, productReducer }) {
  const gaTrackingConfig = useGaTrackingConfig();

  const calcRewardPoints = (totalPayableAmount, cardData) => {
    if (!cardData) return 0;
    return Math.floor(
      (totalPayableAmount / cardData.perRs) *
      cardData.standardPoints *
      (cardData.bonusPoints / cardData.standardPoints + 1),
    );
  };

  const trackAddPaymentInfo = ({
    totalPayableAmount,
    convenienceFee,
    updatedData,
    orderPayload,
  }) => {
    const selectedCard = localStorage.getItem("RewardWidget");
    const cardData = cardListData?.clientConfigData?.cards?.find(
      (card) => card.cardId === selectedCard,
    );
    let totalDenomination = 0;
    let basePayableAmount = 0;
    (updatedData ?? []).forEach((item) => {
      const qty = item.quantity || 0;
      totalDenomination += item.denomination * qty;
      basePayableAmount += item.you_pay * qty;
    });
    const totalDiscount = totalDenomination - basePayableAmount;
    const rewardPoints = calcRewardPoints(totalPayableAmount, cardData);

    trackEvent("add_payment_info", {
      page_type: "checkout_page",
      ...gaTrackingConfig.trackingContext,
      total_gift_card_points: (orderPayload?.products || []).reduce(
        (sum, p) =>
          sum + Number(p?.denomination || 0) * Number(p?.qty || 0),
        0,
      ),
      card_name: selectedCard ? selectedCard : "NA",
      reward_points: rewardPoints,

      DefaultCard: cardData?.cardName || "NA",
      page_url: getCanonicalUrl(),
      ecommerce: {
        currency: "INR",
        value: totalPayableAmount,
        shipping: convenienceFee,
        discount: totalDiscount,
        items: (orderPayload?.products ?? []).map((item) => {
          const denom = Number(item?.denomination || 0);
          const qty = Number(item?.qty || 0);
          const customerDis = ((item?.denomination || 0) * (productReducer?.productReducerDisocount?.customerDiscount || 0)) / 100 * qty;
          const unitYouPay = +(denom - customerDis).toFixed(2);
          return {
            index:
              parseInt(sessionStorage.getItem("ga4_seletedProductIndex")) || null,
            item_brand: item?.name,
            item_name: item?.name,
            item_image: item?.image || defaultImage,
            affiliation: gaTrackingConfig.trackingContext.affiliation,
            item_category: "Giftcards",
            item_category2: productReducer?.productReducer?.clientCategoryName,
            gift_card_points: denom,
            quantity: qty,
            price: unitYouPay,
            item_id: item?.sku,
            item_url: getCanonicalUrl(),
            item_list_name:
              sessionStorage.getItem("ga4_item_list_name") || "",
            item_list_id:
              sessionStorage.getItem("ga4_item_list_name") || "",
            DefaultCard: cardData?.cardName || "NA",
            discount: customerDis,
          };
        }),
      },
    });
  };

  return { trackAddPaymentInfo };
}
